
import {
  Vue, Component, PropSync, Prop, Watch,
} from 'vue-property-decorator';
import DateRangePicker from '@/features/common/components/DateRangePicker.vue';
import { PeriodItemValueType, PeriodItemType } from '@/features/common/raw';
import { getLastDateRangeFromToday } from '@/features/common/helpers/moment';
import { VInput, VSelect } from '../types';

@Component({
  components: {
    DateRangePicker,
  },
})
export default class PeriodPicker extends Vue {
  @PropSync('value', { required: true }) syncedValue!: PeriodItemValueType | string;

  @Prop({ required: true }) items!: PeriodItemType[];

  @Prop({ required: false, default: '' }) initialRange!: string;

  @Prop({ required: false, default: false }) solid!: boolean;

  private period: PeriodItemValueType = 'Last30Days';

  private showCalendar = false;

  private customRange = this.initialRange;

  @Watch('syncedValue', { immediate: true })
  changedSyncedValue(newVal: PeriodItemValueType): void {
    this.period = newVal;
  }

  mounted(): void {
    const { select } = this.$refs;
    if (!select) return;

    const { input: selectInput } = (select as VInput).$refs;
    if (!selectInput) return;

    (selectInput as HTMLInputElement).addEventListener('focus', this.focusHandler, true);
  }

  private changePeriod(value: PeriodItemValueType) {
    this.syncedValue = value;
    this.showCalendar = value === 'Custom';

    if (value === 'Custom') return;

    this.$emit('change', this.convertDateStringToRange(value), value);
  }

  private focusHandler() {
    const { select } = this.$refs;
    if (!select) return;

    (select as VSelect).isMenuActive = true;
  }

  private async applyDateRangeFilter(calendarData: string[]): Promise<void> {
    this.showCalendar = false;
    const [fromDate, toDate] = calendarData;
    this.customRange = calendarData.join('&nbsp;&nbsp;-&nbsp;&nbsp;');
    this.$emit('change', {
      fromDate,
      toDate: toDate || fromDate,
    }, 'Custom');
  }

  private closeCustomRangePicker() {
    this.syncedValue = 'Last7Days';
    this.customRange = '';
  }

  private closeDatePicker() {
    this.showCalendar = false;
    this.syncedValue = 'Last7Days';
  }

  private convertDateStringToRange = (dateString: PeriodItemValueType): {
    fromDate: string,
    toDate: string,
  } | null => {
    return getLastDateRangeFromToday(dateString);
  }
}
